class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.button = document.querySelector(".klaviyo_form_trigger");

    this.button.addEventListener("click", function () {
      const FORM_ID = this.getAttribute("data-form-id")

      console.log(FORM_ID, 'clicked');
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", FORM_ID || "Rmsd5b"]);
    });
  }
}
customElements.define("notify-me", NotifyMe);
